<div [formGroup]="addTravelPartyForm">
  <!-- First Name Input field -->
  <gds-input
    id="firstName"
    formControlName="firstName"
    [errors]="firstNameErrorMsgInfo"
    ngDefaultControl
    [data]="{
            primaryLabel: pageLabels?.['trpAdd.firstName'],
            supportingText: '',
            tooltip: '',
            type: 'text',
            altText: pageLabels?.['trpAdd.firstNameAlt'],
            ariaText: '',
            required: true
            }"
    onkeydown="return /[a-zA-Z]/i.test(event.key)"
    (blurChange)="getErrorMessageInfo($event)"
    onKeyPress=" if( this.value.length === 25 ) return false;"
    (valueChange)="onValueChange($event)"
  >
  </gds-input>
  <gds-spacer classes="spacer-50"></gds-spacer>
  <!-- Last Name Input field -->
  <gds-input
    id="lastName"
    formControlName="lastName"
    [errors]="lastNameErrorMsgInfo"
    ngDefaultControl
    [data]="{
            primaryLabel: pageLabels?.['trpAdd.lastName'],
            supportingText: '',
            tooltip: '',
            type: 'text',
            altText: pageLabels?.['trpAdd.lastNameAlt'],
            ariaText: '',
            required: true
            }"
    onkeydown="return /[a-zA-Z]/i.test(event.key)"
    (blurChange)="getErrorMessageInfo($event)"
    onKeyPress=" if( this.value.length === 30 ) return false;"
    (valueChange)="onValueChange($event)"
  >
  </gds-input>
  <gds-spacer classes="spacer-50"></gds-spacer>
</div>
